/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SubmitDataVerification_submitDataVerification_CreditApplication_validationErrors_CreditApplicationValidationError = { readonly __typename: 'CreditApplicationValidationError', readonly path: string | null, readonly error: string | null };

export type SubmitDataVerification_submitDataVerification_CreditApplication = { readonly __typename: 'CreditApplication', readonly salesforceCreditId: string, readonly validationErrors: ReadonlyArray<SubmitDataVerification_submitDataVerification_CreditApplication_validationErrors_CreditApplicationValidationError | null> | null };

export type SubmitDataVerification_Mutation = { readonly __typename: 'Mutation', readonly submitDataVerification: SubmitDataVerification_submitDataVerification_CreditApplication };


export type SubmitDataVerificationVariables = _Types.Exact<{
  creditTerms: _Types.Scalars['Boolean']['input'];
  creditApplicationId: _Types.Scalars['ID']['input'];
  creditApplicationFetchedAt: _Types.Scalars['NaiveDateTime']['input'];
  clientTimeZone?: _Types.InputMaybe<_Types.Scalars['String']['input']>;
}>;


export type SubmitDataVerification = SubmitDataVerification_Mutation;


export const SubmitDataVerificationDocument = gql`
    mutation SubmitDataVerification($creditTerms: Boolean!, $creditApplicationId: ID!, $creditApplicationFetchedAt: NaiveDateTime!, $clientTimeZone: String) {
  submitDataVerification(
    creditApplicationId: $creditApplicationId
    creditTerms: $creditTerms
    creditApplicationFetchedAt: $creditApplicationFetchedAt
    clientTimeZone: $clientTimeZone
  ) {
    salesforceCreditId
    validationErrors {
      path
      error
    }
  }
}
    `;
export type SubmitDataVerificationMutationFn = Apollo.MutationFunction<SubmitDataVerification, SubmitDataVerificationVariables>;

/**
 * __useSubmitDataVerification__
 *
 * To run a mutation, you first call `useSubmitDataVerification` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitDataVerification` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitDataVerification, { data, loading, error }] = useSubmitDataVerification({
 *   variables: {
 *      creditTerms: // value for 'creditTerms'
 *      creditApplicationId: // value for 'creditApplicationId'
 *      creditApplicationFetchedAt: // value for 'creditApplicationFetchedAt'
 *      clientTimeZone: // value for 'clientTimeZone'
 *   },
 * });
 */
export function useSubmitDataVerification(baseOptions?: Apollo.MutationHookOptions<SubmitDataVerification, SubmitDataVerificationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitDataVerification, SubmitDataVerificationVariables>(SubmitDataVerificationDocument, options);
      }
export type SubmitDataVerificationHookResult = ReturnType<typeof useSubmitDataVerification>;
export type SubmitDataVerificationMutationResult = Apollo.MutationResult<SubmitDataVerification>;
export type SubmitDataVerificationMutationOptions = Apollo.BaseMutationOptions<SubmitDataVerification, SubmitDataVerificationVariables>;